import { RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  time_labels: {
    today: 'Dzisiaj',
    asap: 'Jak najszybciej',
    scheduled: '{{date}}, {{time}}',
  },
  [RoomServiceLocationType.RoomService]: {
    details_label: 'Numer pokoju',
  },
  [RoomServiceLocationType.TableService]: {
    details_label: 'Numer stolika',
  },
};
